import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, ResolveFn, Router } from '@angular/router'
import { catchError, map, of } from 'rxjs'
import { Offer } from '@onedv-flexgate/shared'
import { OfferService } from './offer.service'

export const offerExistsGuard: CanActivateFn = (route) => {
  const offerService = inject(OfferService)
  const router = inject(Router)
  const contractNumber = route.paramMap.get('contractNumber') ?? ''

  return offerService.getOffer(contractNumber).pipe(
    map(() => true),
    catchError(() => of(new RedirectCommand(router.parseUrl('/'))))
  )
}

export const offerResolver: ResolveFn<Offer | null> = (route) => {
  const offerService = inject(OfferService)
  const contractNumber = route.paramMap.get('contractNumber') ?? ''

  return offerService.getOffer(contractNumber).pipe(catchError(() => of(null)))
}
